import { FoldedCornerPlugin } from "../FoldedCornerPlugin";

/**
 * @description Diagrams Pluign
 */
export class DataExportPlugin extends FoldedCornerPlugin {
  name = "Data Export";

  constructor(options, ctx, data) {
      const colors = {
          fill: "#2DA9B4", fillFirstTriangle: "#fdf8fa", fillSecondTriangle: "#43C9D5", stroke: "#FFFFFF"
      };
      super(options, ctx, colors, data);
      this.points = { start: 20, end: 20, initial: 4 };
  }

  draw() {
      super.drawFolded();
  }

  update(options) {
      super.updateFoldedPlugin(options);
  }
}
